export const TaskStatus = {
    COMPLETE: "CompletedSuccessfully",
    FAILED: "Failed",
    NOT_STARTED: "NotStarted",
    IN_PROGRESS: "InProgress",
    INVALID: "Invalid",
    ERROR: "Error",
    READY_TO_FILE: "ReadyToFile"
}